import type { Route } from '../models/Route';
import type { RouteTableRowData } from '../types/routeTable';

export const enrichRouteTableRow = (route: Route): RouteTableRowData => ({
  ...route,
  fecha: route.scheduled,
  startDate: route.startedAt,
  endDate: route.closedAt,
  driverLabel: route.driver
    ? `${route.driver.firstName} ${route.driver.lastName}`
    : 'Sin conductor',
  operatorLabel:
    route.logisticOperator?.name ||
    route.logisticOperator?.businessName ||
    '—',
});
